/* eslint-disable @intlify/vue-i18n/no-dynamic-keys */
const ITEMS = ['ITEM_1', 'ITEM_2', 'ITEM_3'];
const BASE_KEY = 'WGPT_BOTS.EDIT.TABS.TOOLS.LIST.EMPTY_STATE';

export const getEmptyStateContent = t => {
  return ITEMS.map(key => ({
    name: t(`${BASE_KEY}.${key}.NAME`),
    description: t(`${BASE_KEY}.${key}.DESCRIPTION`),
  }));
};
